import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  hoursOfOperationFallbackMessage: {
    id: 'hoursOfOperationFallbackMessage',
    defaultMessage: 'Closed',
    description: 'A message to users that a store is closed.',
  },
  monday: {
    id: 'monday',
    defaultMessage: 'Monday',
    description: 'The day of the week - Monday.',
  },
  tuesday: {
    id: 'tuesday',
    defaultMessage: 'Tuesday',
    description: 'The day of the week - Tuesday.',
  },
  wednesday: {
    id: 'wednesday',
    defaultMessage: 'Wednesday',
    description: 'The day of the week - Wednesday.',
  },
  thursday: {
    id: 'thursday',
    defaultMessage: 'Thursday',
    description: 'The day of the week - Thursday.',
  },
  friday: {
    id: 'friday',
    defaultMessage: 'Friday',
    description: 'The day of the week - Friday.',
  },
  saturday: {
    id: 'saturday',
    defaultMessage: 'Saturday',
    description: 'The day of the week - Saturday.',
  },
  sunday: {
    id: 'sunday',
    defaultMessage: 'Sunday',
    description: 'The day of the week - Sunday.',
  },
  at: {
    id: 'at',
    defaultMessage: 'at',
    description: 'This will be followed by a street address in the UI.',
  },
  waysToOrder: {
    id: 'waysToOrder',
    defaultMessage: 'Ways to order',
    description:
      'A heading for a section listing methods of ordering from a restaurant - delivery, takeout, etc.',
  },
  driveThru: {
    id: 'driveThru',
    defaultMessage: 'Drive Thru',
    description: 'An ordering option: picking up your food at the drive-through.',
  },
  mobileOrdering: {
    id: 'mobileOrdering',
    defaultMessage: 'Mobile Ordering',
    description: 'An ordering option: ordering from your phone.',
  },
  delivery: {
    id: 'delivery',
    defaultMessage: 'Delivery',
    description: 'An ordering option: food delivery.',
  },
  curbside: {
    id: 'curbside',
    defaultMessage: 'Curbside',
    description: 'An ordering option: picking up your order outside a restaurant.',
  },
  catering: {
    id: 'catering',
    defaultMessage: 'Catering',
    description: 'An ordering option: getting an event catered.',
  },
  dineInHours: {
    id: 'dineInHours',
    defaultMessage: 'Dine in hours',
    description: "A heading for a section listing the hours the restaurant's dining room is open.",
  },
  driveThruHours: {
    id: 'driveThruHours',
    defaultMessage: 'Drive Thru hours',
    description:
      "A heading for a section listing the hours the restaurant's drive-through is open.",
  },
  curbsideHours: {
    id: 'curbsideHours',
    defaultMessage: 'Curbside hours',
    description:
      "A heading for a section listing the hours the restaurant's curbside pickup is available.",
  },
});
